<template>
    <ThemeManager />
    <RouterView
        v-if="isMuvalUser"
        v-slot="{ Component, route }"
        name="agent"
    >
        <template v-if="Component">
            <component
                :is="Component"
                v-if="route.meta?.fullscreen"
            />
            <AuthenticatedLayout v-else>
                <component :is="Component" />
            </AuthenticatedLayout>
        </template>
    </RouterView>
    <RouterView
        v-else-if="isRelocationsUser"
        v-slot="{ Component, route }"
        name="relocations"
    >
        <template v-if="Component">
            <component
                :is="Component"
                v-if="route.meta?.fullscreen"
            />
            <AuthenticatedLayout v-else>
                <component :is="Component" />
            </AuthenticatedLayout>
        </template>
    </RouterView>
    <RouterView
        v-else-if="isAffiliatesUser"
        v-slot="{ Component, route }"
        name="affiliates"
    >
        <template v-if="Component">
            <component
                :is="Component"
                v-if="route.meta?.fullscreen"
            />
            <AuthenticatedLayout v-else>
                <component :is="Component" />
            </AuthenticatedLayout>
        </template>
    </RouterView>
    <RouterView
        v-else
        v-slot="{ Component, route }"
    >
        <template v-if="Component">
            <component
                :is="Component"
                v-if="route.meta?.fullscreen"
            />
            <AuthenticatedLayout v-else>
                <component :is="Component" />
            </AuthenticatedLayout>
        </template>
    </RouterView>
    <ToastNotification
        v-if="showLayout"
        class="z-50"
    />
</template>
<script setup>
import ThemeManager from '@components/utilities/ThemeManager.vue';

const appStore = useAppStore();
const userStore = useUserStore();

const route = useRoute();

const isMuvalUser = computed(() => {
    return userStore.hasAnyRole(['MUVAL_AGENT', 'MUVAL_ADMIN', 'MUVAL_TRIAGE', 'MUVAL_COMPANY', 'SUPER']);
});

const isRelocationsUser = computed(() => {
    return userStore.hasAnyRole(['RELOCATIONS_MANAGER']);
});

const isAffiliatesUser = computed(() => {
    return userStore.hasAnyRole(['AFFILIATE_MANAGER']);
});

const showLayout = computed(() => {
    return (
        userStore.isAuthenticated &&
        route.name !== 'Login' &&
        route.name !== 'Register' &&
        route.name !== 'Update your preferences'
    );
});

onMounted(async () => {
    appStore.setDeviceType();
    await appStore.initGoogle();
});
</script>
<style>
/* width */
::-webkit-scrollbar {
    width: 5px;
    padding: 5px;
    border-radius: 10px;
}

/* Track */
::-webkit-scrollbar-track {
    border-radius: 10px;
    padding: 5px;
}

/* Handle */
::-webkit-scrollbar-thumb {
    background: #c4c4c4;
    padding: 5px;
    border-radius: 10px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
    background: #c4c458;
}
</style>
